var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg7425(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_822_1665)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_822_1665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 3.8147e-06H48.7998V48H0.799805V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_822_1665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5422 38.8828V32.5593C30.5422 32.2171 30.4119 31.8871 30.1784 31.6378L27.9303 29.2359C27.6753 28.964 27.3191 28.8093 26.9459 28.8093H24.5337H20.3234C19.7703 28.8093 19.2931 29.1431 19.0859 29.6212V29.6221C19.0137 29.7862 18.9744 29.9681 18.9744 30.1584V35.4555",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0339 23.04L24.1614 27.8756C24.3508 28.169 24.4735 28.4859 24.5336 28.8093",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0175 20.0793C15.246 20.5781 14.8269 21.4153 14.8269 22.2703C14.8269 22.7549 14.9618 23.2454 15.2441 23.6822L19.0859 29.6221",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9707 15.2714L27.315 17.3502C27.7251 17.9844 27.5434 18.8309 26.9093 19.2411L18.8467 24.4548C17.6384 25.2361 16.0255 24.8901 15.2442 23.6818C14.463 22.4736 14.809 20.8608 16.0173 20.0795L24.0799 14.8657C24.7141 14.4556 25.5607 14.6372 25.9707 15.2714Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2312 15.2026L26.6165 16.27",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7998 39.9482V36.2979",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4036 36.7331V25.3133C34.4036 24.3834 35.1573 23.6305 36.0863 23.6305H40.7428",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.423 8.13331C34.4686 8.94668 40.748 15.74 40.748 23.9999C40.748 32.8078 33.6078 39.9481 24.7998 39.9481C15.9918 39.9481 8.85156 32.8078 8.85156 23.9999C8.85156 15.7526 15.1119 8.9674 23.1397 8.13715",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1273 19.1581H43.8953C43.4237 17.2925 42.6857 15.5333 41.7245 13.9225L43.3043 12.3428C44.0734 11.5738 44.0734 10.3267 43.3043 9.5576L39.2422 5.49551C38.473 4.72638 37.226 4.72638 36.457 5.49551L34.8772 7.07519C33.2663 6.11398 31.5071 5.37598 29.6416 4.90441V2.67241C29.6416 1.58482 28.7598 0.703007 27.6722 0.703007H21.9274C20.8398 0.703007 19.9579 1.58482 19.9579 2.67241V4.90441C18.0925 5.37598 16.3332 6.11398 14.7224 7.07519L13.1426 5.49551C12.3736 4.72638 11.1266 4.72638 10.3574 5.49551L6.29534 9.5576C5.52621 10.3267 5.52621 11.5738 6.29534 12.3428L7.87512 13.9225C6.9139 15.5333 6.1759 17.2925 5.70424 19.1581H3.47234C2.38465 19.1581 1.50293 20.0399 1.50293 21.1276V26.8723C1.50293 27.96 2.38465 28.8418 3.47234 28.8418H5.70424C6.1759 30.7072 6.9139 32.4665 7.87512 34.0773L6.29534 35.6569C5.52621 36.4261 5.52621 37.6731 6.29534 38.4423L10.3574 42.5043C11.1266 43.2735 12.3736 43.2735 13.1426 42.5043L14.7224 40.9247C16.3332 41.8859 18.0924 42.6239 19.9579 43.0954V45.3274C19.9579 46.415 20.8398 47.2968 21.9274 47.2968H27.6722C28.7598 47.2968 29.6416 46.415 29.6416 45.3274V43.0954C31.5072 42.6239 33.2663 41.8859 34.8772 40.9247L36.457 42.5043C37.226 43.2735 38.473 43.2735 39.2422 42.5043L43.3043 38.4423C44.0734 37.6731 44.0734 36.4261 43.3043 35.6569L41.7245 34.0773C42.6857 32.4665 43.4237 30.7072 43.8953 28.8418H46.1273C47.215 28.8418 48.0967 27.96 48.0967 26.8723V21.1276C48.0967 20.0399 47.215 19.1581 46.1273 19.1581Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1253 26.753C38.1253 27.1892 37.7718 27.5428 37.3356 27.5428C36.8995 27.5428 36.5459 27.1892 36.5459 26.753C36.5459 26.317 36.8995 25.9634 37.3356 25.9634C37.7718 25.9634 38.1253 26.317 38.1253 26.753Z",
    fill: "#102E7A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_822_1665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.799805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg7425);
export default __webpack_public_path__ + "static/media/svg7425.8dcde0b67968997b438c930caa931c6b.svg";
export { ForwardRef as ReactComponent };